import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IClosedDaysInput } from "@/interfaces/closed-days.interface";
import closedDaysService from "@/services/closed-days.service";
import { RequestsProps } from "@/types/requests.types";

export type Props = {
  formData: IClosedDaysInput;
} & RequestsProps;

export type Return = {
  create: (props: Props) => Promise<void>;
} & UseLoadingReturn;

const useCreateClosedDays = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IClosedDaysInput>({
    operation: (formData) => closedDaysService.create(formData),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, create };
};

export default useCreateClosedDays;
